const en = {
	list: {
		pending: 'Pending Appeal',
		close: 'Closed',
		disputeId: 'Dispute ID',
		originId: 'Merchant Transaction ID',
		omniOriginId: 'Merchant Transaction ID',
		nocases: 'No cases',
		originalOrderIDWebsite: 'MerchantTransaction ID/Website',
		websiteOrGroup: 'Website/Group',
		omniWebsiteOrGroup: 'Store/Website/Group',

		creationTime: 'Create Time',
		time: 'Time',
		deadline: 'Deadline',
		completeTime: 'Completed Time',
		amount: 'Amount',
		reason: 'Reason'
	},
	detail: {
		disputeDetail: 'Dispute Detail',
		cardAssociation: 'Card Association',
		orderDetail: 'Original Transaction Information',
		websiteURL: 'Website URL',
		transactionID: 'Purchase Transaction ID',
		itemName: 'Logistics Information',
		amount: 'Amount',
		transactionTime: 'Transaction Time',
		shippingName: 'Shipping Name',
		clientEmail: 'Client Email',
		shippingPhoneNumber: 'Shipping Phone Number',
		process: 'Retrieval Process',
		required: 'This field is required',
		processedOptions: [
			'No response',
			'Unjustified claim',
			'Resolved'
		],
		commentLog: 'Comment Log',
		processed: 'Processed',
		pleaseSelect: 'Please Select',
		comment: 'Comment',
		cancel: 'Cancel',
		confirm: 'Confirm',
		successful: 'Operation Successful',
		failure: 'Operation failure'
	}
}

export default en
